import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import SearchIcon from 'assets/icons/search-icon'
import ClearIcon from 'assets/icons/clear-icon'
import {
  SpeciesSearchInputContainer,
  SpeciesSearchIconWrapper,
  SpeciesSearchClearButton,
  SpeciesSearchInputField
} from './style'

const SpeciesSearchInput = ({ value, onChange }) => {
  const intl = useIntl()

  return (
    <SpeciesSearchInputContainer>
      <SpeciesSearchIconWrapper aria-hidden="true">
        <SearchIcon />
      </SpeciesSearchIconWrapper>
      <SpeciesSearchInputField
        type="search"
        value={value}
        onChange={onChange}
        placeholder={intl.formatMessage({ id: 'speciesCriteriaMetSearchPlaceholder' })}
        aria-label={intl.formatMessage({ id: 'speciesCriteriaMetSearchPlaceholder' })}
        id="species-criteria-met-search"
        data-test="species-criteria-met-search"
      />
      {value ? (
        <SpeciesSearchClearButton
          type="button"
          onClick={() => onChange({ target: { value: '' } })}
          aria-label={intl.formatMessage({ id: 'clearResults' })}
          data-test="species-criteria-met-search-clear"
        >
          <ClearIcon />
        </SpeciesSearchClearButton>
      ) : null}
    </SpeciesSearchInputContainer>
  )
}

SpeciesSearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default SpeciesSearchInput
